import React from 'react'
import { I18n } from 'react-redux-i18n'
import { Button } from 'reactstrap'

const SignupErrorInvalidToken = (props) => {
  return (
    <div className="nfrl">
      <div className="error-invalid-token">
        <div className='animated fadeIn'>
          <div className='logo-container'>
            <img src={'/img/logo-white.svg'} alt='Logo' />
          </div>

          <div className="page-container">
            <div className='form-title'>{props.title}</div>

            <div className="error-description">{props.description}</div>

            {props.showBtnLogin && <Button className='submit-button' onClick={props.clickBtnLogin}>
              <div>{I18n.t('dashboard_go-back')}</div>
            </Button>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignupErrorInvalidToken